const middleware = {}

middleware['auth.hook'] = require('../../../../apps/member-area/src/middleware/auth.hook.ts')
middleware['auth.hook'] = middleware['auth.hook'].default || middleware['auth.hook']

middleware['auth'] = require('../../../../apps/member-area/src/middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['auth.store'] = require('../../../../apps/member-area/src/middleware/auth.store.js')
middleware['auth.store'] = middleware['auth.store'].default || middleware['auth.store']

export default middleware
